import React, { useEffect } from "react";
import classes from "./styles.module.scss";
import SideItem from "./sideItems";
import { connect, useDispatch, useSelector } from "react-redux";
import { importAdminDataFromLocal, onLogout } from "../../../store/auth/actions";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { setSidebarOpen, toggleNavIsOpen } from "../../../store/nav/reducer";
import { useNavigate } from "react-router-dom";

const logo = "https://prod-1.static.codebuckets.in/file/codebucket-production-public/prepca-blog/image_logo.jpeg";

const LeftBar = (props) => {
  const currentTheme = useSelector((state) => state.setCurrentTheme);

  useEffect(() => {
    props.importAdminDataFromLocal();
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOpen = useSelector((state) => state.setIsSidebar.isOpen);

  const handleHamburgerClick = () => {
    dispatch(setSidebarOpen(!isOpen));
  };

  const setNavIsOpen = (data) => {
    dispatch(toggleNavIsOpen(data));
  };

  const handleLogout = () => {
    dispatch(onLogout(navigate));
  };

  return (
    <div className={classes.container} style={{ backgroundColor: currentTheme.bg2 }}>
      <div
        className={`${classes.sidebar} ${isOpen ? classes.sidebar_active : classes.sidebar_collapsed
          }`}
      >
        <div className={classes.card} style={{ backgroundColor: currentTheme.bg3 }}>
          <div className={classes.card_head}>
            <img
              src={logo}
              style={{
                cursor: "pointer",
                // width: isOpen ? "150px" : "40px",
                width: "auto",
                height: isOpen ? "60px" : "30px",
                transition: "0.3s",
              }}
              onClick={() => navigate("/admin/view-orders")}
              alt="logo"
            />

            {/* 
            <div >
              {isOpen ? (
                <MenuOpenIcon onClick={handleHamburgerClick} fontSize="large" color="primary" />
              ) : (
                <MenuOpenIcon onClick={handleHamburgerClick} fontSize="large" color="primary" />
              )}


            </div> */}

          </div>
          <div className={classes.card_body}>
            <div
              // className={classes.left_bar}
              style={{ width: isOpen ? "240px" : "60px" }}
            >

              <div className={classes.content}>
                {props?.auth?.navItems?.map((navItem, index) => (
                  <SideItem
                    key={index}
                    type={props?.type}
                    to={navItem.to}
                    items={navItem}
                    setNavIsOpen={setNavIsOpen}
                    isOpen={isOpen}
                  />
                ))}

                {isOpen && (
                  <p
                    className={classes.logout_btn}
                    onClick={handleLogout}
                    style={{
                      color: currentTheme.text2,
                      backgroundColor: currentTheme.bg6,
                      marginLeft: "16px",
                      marginTop: "6px",
                      cursor: "pointer",
                    }}
                  >
                    Logout
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginLeft: isOpen ? "240px" : "60px" }} className={classes.right_bar}>{props.children}</div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.Auth,
});

const mapDispatchToProps = { importAdminDataFromLocal };

export default connect(mapStateToProps, mapDispatchToProps)(LeftBar);
